"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var Vibrant = require("./browser");
var pipeline_1 = __importDefault(require("./pipeline"));
Vibrant.use(pipeline_1.default);
module.exports = Vibrant;
//# sourceMappingURL=bundle.js.map